import Flickity from 'flickity'
import UI from './utils/UI'
import { mq } from 'config'
import bus from './bus'

UI({
  component: '.js-carouselOriginalChain',
  carousel: '.js-carouselOriginalChain-carousel',
  cells: ['.js-carouselOriginalChain-cell']
}, ({ component, carousel, scrollr }) => {

  const carouselFlkty = new Flickity(carousel, {
    arrowShape: 'M92.857 42.403h-68.47l28.214-28.214c2.786-2.786 2.786-7.307 0-10.1-2.793-2.785-7.314-2.785-10.1 0L2.095 44.496a7.135 7.135 0 0 0 0 10.1L42.5 95.001a7.135 7.135 0 0 0 10.1 0c2.786-2.793 2.786-7.314 0-10.1L24.387 56.688h68.47c3.943 0 7.143-3.2 7.143-7.142 0-3.943-3.2-7.143-7.143-7.143',
    contain: false,
    wrapAround: false,
    pageDots: false,
    groupCells: mq.md.matches ? 2 : false
  })

  bus.on('window-resize', _ => {
    carouselFlkty.options.groupCells = mq.md.matches ? 2 : false
    carouselFlkty.reloadCells()
  })
})
